// src/components/DialogHost.jsx — renders the themed confirm/prompt/alert used
// by src/utils/dialog.js. Mounted once, globally, in App.
import { useState, useEffect, useRef } from 'react';
import { registerDialogHandler } from '../utils/dialog';

export default function DialogHost() {
  const [dlg, setDlg] = useState(null); // { kind, title, message, resolve, ... }
  const [val, setVal] = useState('');
  const inputRef = useRef(null);

  useEffect(() => registerDialogHandler((d) => { setVal(d.defaultValue || ''); setDlg(d); }), []);
  useEffect(() => { if (dlg?.kind === 'prompt') setTimeout(() => inputRef.current?.focus(), 60); }, [dlg]);

  if (!dlg) return null;

  const close = (result) => { dlg.resolve?.(result); setDlg(null); };
  const onConfirm = () => close(dlg.kind === 'prompt' ? val : true);
  const onCancel  = () => close(dlg.kind === 'prompt' ? null : false);

  const danger = !!dlg.danger;
  return (
    <div onClick={onCancel} style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 360, background: 'var(--white)', borderRadius: 18, boxShadow: '0 24px 60px rgba(0,0,0,0.28)', overflow: 'hidden', animation: 'ttDlgIn 0.16s ease' }}>
        <style>{`@keyframes ttDlgIn { from { transform: scale(0.94); opacity: 0.5; } to { transform: none; opacity: 1; } }`}</style>
        <div style={{ padding: '22px 22px 16px' }}>
          {dlg.title && <div style={{ fontFamily: 'var(--display)', fontSize: 17, fontWeight: 800, color: 'var(--txt)', marginBottom: dlg.message ? 8 : 0 }}>{dlg.title}</div>}
          {dlg.message && <div style={{ fontSize: 13.5, color: 'var(--txt-m)', lineHeight: 1.55 }}>{dlg.message}</div>}
          {dlg.kind === 'prompt' && (
            <input ref={inputRef} className="form-input" value={val} placeholder={dlg.placeholder || ''}
              onChange={e => setVal(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') onConfirm(); if (e.key === 'Escape') onCancel(); }}
              style={{ marginTop: 14, width: '100%', boxSizing: 'border-box', fontSize: 14 }} />
          )}
        </div>
        <div style={{ display: 'flex', borderTop: '1px solid var(--nat-d)' }}>
          {dlg.kind !== 'alert' && (
            <button onClick={onCancel} style={{ flex: 1, padding: '13px', background: 'none', border: 'none', borderRight: '1px solid var(--nat-d)', cursor: 'pointer', fontSize: 14, fontWeight: 700, color: 'var(--txt-m)' }}>
              {dlg.cancelText || 'Cancel'}
            </button>
          )}
          <button onClick={onConfirm} style={{ flex: 1, padding: '13px', background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 800, color: danger ? 'var(--err)' : 'var(--org)' }}>
            {dlg.confirmText || (dlg.kind === 'alert' ? 'OK' : dlg.kind === 'prompt' ? 'Submit' : 'Confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
